// extracted by mini-css-extract-plugin
module.exports = {"containerIP":"_1Q330jK234lRbfEg1fLJJU","messageInfos":"Mi09c28k50dNQbSyUGuaM","infoLabel":"_31vJQAY2c8EgtmzmWGIgZS"};